<template>
    <v-form @submit.prevent="createAttCorrections" ref="form">
        <v-card dense class="rounded-4">
            <v-toolbar flat height="50px">
                <span class="font-weight-bold">{{mode}} Attendance Corrections</span>
                <v-spacer></v-spacer>
                <help-link appId="attendance" pageId="attendance-corrections" color="black" v-if="!isMobile"></help-link>
                <v-btn icon @click.native="closeDialog" :disabled="disabled" title="Close">
                    <b>X</b>
                </v-btn>
            </v-toolbar>
            <v-card-text dense>

                <v-alert v-if="error" :value="true" color="error" icon="error" outline class="mt-8">
                    Error encountered. Please contact support. Error details: {{errorMessage}}
                </v-alert>  
                <v-alert v-if="attCorrectionsStatus==commonfn.getStatusCode('Approved')" :value="true" color="warning" icon="warning" outline class="mt-8">
                    This is already approved. Clicking Save will update back to For Review.
                </v-alert> 
                
                <v-layout row wrap>
                    <v-flex xs12 sm12 class="mt-10 mr-25 ml-25">  

                        <!-- User Selector - display only if created from My Teams -->
                        <v-layout v-if="createdFromMyTeams" row wrap>
                            <v-flex xs12 sm12 class="mb-15">
                                <v-chip class="user-chip-container">
                                    <v-avatar>
                                        <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(userId)"></v-img>
                                    </v-avatar>
                                    {{firstName}} {{lastName}}
                                </v-chip>
                            </v-flex>
                        </v-layout>

                        <!-- date -->
                        <v-layout row v-if="isMobile">  
                            <v-flex xs12>
                               <div class="caption grey--text">Date</div>
                               {{transDate | moment('YYYY-MM-DD (dddd)')}}
                            </v-flex>
                        </v-layout>
                        <v-layout row v-else>  
                            <v-flex xs3>
                               Date :
                            </v-flex> 
                            <v-flex xs9>
                                {{transDate | moment('YYYY-MM-DD (dddd)')}}
                            </v-flex>      
                        </v-layout>

                        <!-- Work Shift -->
                        <v-layout row v-if="isMobile" class="mt-15">  
                            <v-flex xs12>
                                <div class="caption grey--text">Workshift</div>
                                {{workShift}}
                            </v-flex> 
                        </v-layout>
                        <v-layout row v-else class="mt-15">  
                            <v-flex xs3>
                                Workshift :
                            </v-flex> 
                            <v-flex xs9>
                                {{workShift}}
                            </v-flex>      
                        </v-layout>

                        <!-- clock-in/out -->
                        <v-layout row class="mt-15">  
                            <v-flex xs12 sm6 class="mr-15">
                                <v-menu
                                    ref="menuClockStart"
                                    v-model="menuClockStart"
                                    :close-on-content-click="false"
                                    :return-value.sync="timeClockStart"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        label="Clock-In"
                                        v-model="timeClockStart"
                                        readonly
                                        v-on="on"
                                        :rules="[rules.required]" 
                                    ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="menuClockStart"
                                        v-model="timeClockStart"
                                        @click:minute="$refs.menuClockStart.save(timeClockStart)"
                                        :allowed-hours="allowedHoursStart"
                                        full-width
                                        scrollable
                                        format="ampm"
                                    ></v-time-picker>
                                </v-menu>
                            </v-flex>
                            <v-flex xs12 sm6 class="ml-15">
                                <v-menu
                                    ref="menuClockEnd"
                                    v-model="menuClockEnd"
                                    :close-on-content-click="false"
                                    :return-value.sync="timeClockEnd"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                >
                                    <template v-slot:activator="{ on }">
                                    <v-text-field
                                        label="Clock-Out"
                                        v-model="timeClockEnd"
                                        readonly
                                        v-on="on"
                                        :rules="[rules.required]" 
                                    ></v-text-field>
                                    </template>
                                    <v-time-picker
                                        v-if="menuClockEnd"
                                        v-model="timeClockEnd"
                                        @click:minute="$refs.menuClockEnd.save(timeClockEnd)"
                                        :allowed-hours="allowedHoursEnd"
                                        full-width
                                        scrollable
                                        format="ampm"
                                    ></v-time-picker>
                                </v-menu>
                            </v-flex>
                        </v-layout> 

                        <!-- remarks -->
                        <v-layout row class="mt-0">  
                            <v-flex xs12>
                                <v-textarea v-model="remarks" 
                                    :rules="[rules.required]"
                                    maxlength="150"
                                    hint="150 characters max"
                                    label="Comments" rows="1" color="primary"></v-textarea>
                            </v-flex>      
                        </v-layout>

                    </v-flex>
                </v-layout>
            </v-card-text>  
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn v-if="mode=='Add'" @click="clearForm" :disabled="disabled">Clear</v-btn>
                <v-btn color="primary" type="submit" :loading="loading" class="mr-20">
                    <span v-if="mode=='Add'">Save</span>
                    <span v-if="mode=='Edit'">Update</span>
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>

import attCorrectionsApi from '@/api/attendancecorrection'
import employeeApi from '@/api/employees'
import commonfn from '@/common/functions'   //for refactor
import pageKeys from '@/common/pagekeys'
import awsS3Helper from '@/helpers/aws-s3'

export default {
    data() {
        return {
            awsS3Helper,
            commonfn,
            error: false,
            errorMessage: '',
            transDate: '',
            workShift: '',
            disabled: false,
            loading: false,
            loading_employees: false,
            
            //for refactor - put these rules in a single rules-helper.js
            rules: {
                required: value => !!value || 'Required.',
                min: v => v.length >= 8 || 'Min 8 characters',
            },
            
            menuClockStart: false,
            timeClockStart: null,
            menuClockEnd: false,
            timeClockEnd: null,
            startDate: new Date().toISOString().substr(0, 10),
            menuStartDate: false,
            endDate: new Date().toISOString().substr(0, 10),
            menuEndDate: false,
            remarks: '',
            mode: '',
            createdFromMyTeams: false,
            approved: false,
            attCorrectionsStatus: '',
            attendanceCorrectionsId: '',
            userId: null,
            firstName: null,
            lastName: null,
            workshiftClockStart: null,
            workshiftClockEnd: null,
            maxMinAllowedHours: 8   //extension hours before/after the workshift clockhours
                                    //eg if set to 1, can only set clock-in/out 1hr ealier or 1hr later   
                                    //future updates, add this as company settings
        }
    },
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
    },
    methods: {
        allowedHoursStart(hour) {
            const lowerBound = (this.workshiftClockStart - this.maxMinAllowedHours + 24) % 24;
            const upperBound = (this.workshiftClockStart + this.maxMinAllowedHours + 24) % 24;

            if (lowerBound > upperBound) {
                // Handle wraparound case
                return hour >= lowerBound || hour <= upperBound;
            } else {
                return hour >= lowerBound && hour <= upperBound;
            }
        },
        allowedHoursEnd(hour) {
            const lowerBound = (this.workshiftClockEnd - this.maxMinAllowedHours + 24) % 24;
            const upperBound = (this.workshiftClockEnd + this.maxMinAllowedHours + 24) % 24;

            if (lowerBound > upperBound) {
                // Handle wraparound case
                return hour >= lowerBound || hour <= upperBound;
            } else {
                return hour >= lowerBound && hour <= upperBound;
            }
        },
        setParams(data) { 
            this.mode = data.mode
            this.transDate = data.transDate
            this.workShift = data.workshift
            this.userId = data.userId
            this.workshiftClockStart = parseInt(this.$moment(data.clockStart).format('H'))
            this.workshiftClockEnd = parseInt(this.$moment(data.clockEnd).format('H'))

            if (data.mode == 'Edit') {
                //edit mode
                this.attendanceCorrectionsId = data.attendanceCorrectionsId
                this.timeClockStart = this.$moment(data.clockIn).format('H:mm')
                this.timeClockEnd = this.$moment(data.clockOut).format('H:mm')
                this.attCorrectionsStatus = data.attCorrectionsStatus 
                this.remarks = data.remarks
            } else {
                //add mode
                this.createdFromMyTeams = data.createdFromMyTeams
                this.timeClockStart = this.$moment(data.clockStart).format('H:mm')
                this.timeClockEnd = this.$moment(data.clockEnd).format('H:mm')

                if (this.createdFromMyTeams) {
                    this.firstName = data.firstName
                    this.lastName = data.lastName
                }
            }
        },
        async createAttCorrections() {
            try {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    this.disabled = true

                    const data = {    
                        attendanceCorrectionsId : this.attendanceCorrectionsId,    
                        userId: this.userId,
                        transDate : this.transDate,
                        clockIn : this.timeClockStart,
                        clockOut: this.timeClockEnd,
                        remarks: this.remarks
                    }
                    var response = null
                    
                    if (this.mode == 'Add') {
                        if (this.createdFromMyTeams) {
                            const teamId = this.$store.state.selectedTeamId
                            const pageKey = pageKeys.attendance_corrections_team_approver
                            response = await attCorrectionsApi.addFromMyTeams(data, teamId, pageKey)
                        }
                        else 
                            response = await attCorrectionsApi.add(data)
                    } 
                    else {
                        //update will always happen on details page
                        response = await attCorrectionsApi.update(data)
                    }

                    if (response && response.status == 200) {
                        this.clearForm()
                        this.$emit('send',null)
                        this.closeDialog()
                    }

                    this.loading = false
                    this.disabled = false
                }
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
        clearForm() {
            this.$refs.form.reset()
            this.loading = false
            this.error = false
        },
        closeDialog() {
            this.$emit('update:dialogAttendanceCorrections', false)
        }
    },
}
</script>